import { AbstractDataProviderV2, adapter, DataProvider } from 'components/system';
import { CustomerUpdateActive } from 'common/customers/services/types/CustomerUpdateActive';
import { RsCustomerBank } from 'common/customers/services/types/RsCustomerBank';
import { RsCustomerBankInfo } from 'common/customers/services/types/RsCustomerBankInfo';
import { CustomerBankAdd } from 'common/customers/services/types/CustomerBankAdd';
import { CustomerBankUpdate } from 'common/customers/services/types/CustomerBankUpdate';

export class CustomerBankDataProvider extends AbstractDataProviderV2<RsCustomerBank, RsCustomerBankInfo, CustomerBankAdd, CustomerBankUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/banks');
    }

    public add(item, resourceParams = {}) {
        return this._getNextOrderNo(resourceParams).then(orderNo => {
            item.orderNo = orderNo;
            item.iban = this.removeSpaces(item.iban);
            item.bic = this.removeSpaces(item.bic);

            return super.add(item, resourceParams);
        });
    }

    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }

    _getNextOrderNo(resourceParams = {}) {
        return this.all({}, resourceParams).then(items => {
            let orderNo = 0;
            items.forEach(item => (orderNo = Math.max(orderNo, item.orderNo)));
            return orderNo + 1;
        });
    }

    removeSpaces(input) {
        return input && input.replace(/\s+/g, '');
    }
}
